export default __webpack_public_path__ + "static/media/1.fb0a58e6.jpg";